var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "图片剪裁",
        visible: _vm.dialogVisible,
        "append-to-body": "",
        "custom-class": "cropper-dialog",
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c("div", { staticClass: "cropper-content" }, [
        _c(
          "div",
          { staticClass: "cropper", staticStyle: { "text-align": "center" } },
          [
            _c("VueCropper", {
              ref: "cropper",
              attrs: {
                img: _vm.option.img,
                "output-size": _vm.option.outputSize,
                "output-type": _vm.option.outputType,
                info: _vm.option.info,
                "can-scale": _vm.option.canScale,
                "can-move-box": _vm.option.canMoveBox,
                "can-move": _vm.option.canMove,
                "auto-crop": _vm.option.autoCrop,
                "auto-crop-width": _vm.option.autoCropWidth,
                "auto-crop-height": _vm.option.autoCropHeight,
                fixed: _vm.option.fixed,
                "fixed-number": _vm.option.fixedNumber,
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "tip-box tips" }, [
          _c("i", { staticClass: "el-icon-question icon" }),
          _vm._v(" "),
          _c("span", { staticClass: "text" }, [
            _vm._v("可通过鼠标滚轮缩放大小。"),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.cancelCropper } }, [
            _vm._v("取消"),
          ]),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _vm.uploading },
              on: { click: _vm.ensureCropper },
            },
            [_vm._v("确定")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }